import { createFileRoute, Outlet } from "@tanstack/react-router";

// KaTeX CSS is attached per-page by the docs catch-all route ($.tsx) when the
// loaded doc actually contains math — not here, where every doc would pay for it.
export const Route = createFileRoute("/($locale)/docs")({
  component: () => <Outlet />,
});
